import { useState } from 'react'
import Card from 'shared/Cards/Card'
import TextField from 'shared/Forms/TextField'
import NumberInput from 'shared/Inputs/NumberInput'
import Button from 'shared/Buttons/Button/Button'
import { ITeamReviewFormResponse, ITeamSubmitReviewDto } from 'screens/Protection/protection.types'
import { useParams } from 'react-router-dom'
import eventBus from 'services/eventBus'
import TextInput from 'shared/Inputs/TextInput'
import { useNavigate } from 'react-router-dom'

type Props = {
  data: ITeamReviewFormResponse
  values: Record<string, number>
  setValues: React.Dispatch<React.SetStateAction<Record<string, number>>>
  onSubmit: (payload: ITeamSubmitReviewDto) => void
}

const ProtectionInfoGrade = ({ data, onSubmit, setValues, values }: Props) => {
  const params = useParams()
  const navigate = useNavigate()

  const [messages, setMessages] = useState<Record<string, string>>(() =>
    Object.fromEntries(data.criteria.map((c) => [c.id, c.currentComment ?? '']))
  )

  const handleChange = (id: string, value: number, max: number) => {
    const normalized = Math.max(0, Math.min(value, max))

    setValues((prev) => ({
      ...prev,
      [id]: normalized,
    }))
  }

  const handleMessageChange = (id: string, value: string) => {
    setMessages((prev) => ({
      ...prev,
      [id]: value,
    }))
  }

  const handleSubmit = () => {
    for (const criterion of data.criteria) {
      const value = values[criterion.id] ?? 0

      if (value < 0 || value > criterion.maxValue) {
        eventBus.pub('ntf.message', {
          type: 'warn',
          message: `Оценка "${criterion.name}" должна быть в диапазоне от 0 до ${criterion.maxValue}`,
        })
        return
      }
    }

    const payload: ITeamSubmitReviewDto = {
      defenceId: params.id,
      teamId: data.team.id,
      scores: data.criteria.map((c) => ({
        criterionId: c.id,
        value: values[c.id] ?? 0,
        comment: messages[c.id] ?? '',
      })),
    }

    onSubmit(payload)
    navigate(-1)
  }

  return (
    <Card type='normal'>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div>
          <h2 className='text--caption-l text-700'>Оценка защиты</h2>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 16,
            alignItems: 'stretch',
          }}
        >
          {data.criteria.map((c) => (
            <>
              <TextField
                key={c.id}
                header={`${c.name} (${values[c.id] ?? 0}/${c.maxValue})`}
                style={{ height: '100%' }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <NumberInput
                    name={c.id}
                    value={values[c.id] ?? 0}
                    onChange={(val, name) => handleChange(name, val, c.maxValue)}
                  />
                  <span style={{ fontSize: 12, opacity: 0.7 }}>{c.description}</span>
                </div>
              </TextField>
              <TextField key={c.id} header={`Комментарий`} style={{ height: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <TextInput
                    name={c.id}
                    value={messages[c.id] ?? ''}
                    onChange={(value) => handleMessageChange(c.id, value)}
                    required={false}
                  />
                  <span style={{ fontSize: 12, opacity: 0.7 }}>{c.description}</span>
                </div>
              </TextField>
            </>
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          <Button theme='primary' onClick={handleSubmit} fullWidth={false}>
            Сохранить
          </Button>
        </div>
      </div>
    </Card>
  )
}

export default ProtectionInfoGrade
